export const FILE_ALLOW_SIZE = 3 * 1024 * 1024;